import { combineReducers } from 'redux';
import { command } from './redux_reducers/command';

const reducers = combineReducers({
  command
});

export default reducers;
